module.exports = __webpack_public_path__ + "static/media/modern-architecture-luis-carranza.66e90adf.jpg";